import { Point } from 'highcharts';
import Highcharts from 'highcharts/highstock';

import { TimeSeriesPointCustom } from '@/components/Chart/utils/buildChartLineSeries';
import { findClosestPoint } from '@/components/Chart/utils/findClosestPoint';
import { formatPriceValue } from '@/utils/formatPriceValue';

export const createTooltip = (
  allChartSeries: Highcharts.Series[],
  hoveredPointXValue: string | number | undefined,
  createHeader: () => string,
  createBodyRow: (point: Point, custom: TimeSeriesPointCustom, value: string) => string
): string => {
  allChartSeries = allChartSeries.filter(series => !series.name.includes('Navigator'));

  const points: Highcharts.Point[] = allChartSeries
    .filter(series => series.visible && series.points)
    .map(series => findClosestPoint(series.points, Number(hoveredPointXValue)))
    .filter(x => !!x);
  const header = createHeader();

  const body = points
    .map(point => {
      // @ts-expect-error: highcharts rules.
      const custom = point.custom as TimeSeriesPointCustom;
      let value = '';
      if (point.y !== undefined && !Number.isNaN(point.y)) {
        value = formatPriceValue(custom?.decimalPlaces ?? 2, point.y);
      }
      return createBodyRow(point, custom, value);
    })
    .join('');
  return header + body;
};
